import createAxios from 'App/utils/createAxios';
import config from '../components/config/config';
import getSlsBasePath from '../utils/getSlsBasePath/getSlsBasePath';

const slsHost = getSlsBasePath(config, 'integration');
const integrationSlsBaseUrl = `${slsHost}/${config.slsVersion}`;

const slsintegration = createAxios({
    baseURL: integrationSlsBaseUrl,
});

const phpApi = createAxios({
    baseURL: '/app.api.php/api',
});

/**
 * find pdx patient by external ID
 * @returns patient data
 */
function slsGetPDXPatient(pdxId) {
    return slsintegration.get(`/getPdxPatients?rxcomId=${pdxId}`);
}

/**
 * search patients in pdx for the given search parameters
 * @returns patients data
 */
function slsSearchPDX(params) {
    return slsintegration
        .get(`/getPdxPatients`, { params })
        .then((response) => response.results)
        .catch((error) => {
            throw error;
        });
}

function phpGetPDXPatient(id) {
    return phpApi.get(`/patient/pdx/${id}`);
}

function formatForPdx(params) {
    const result = {};
    for (const key of Object.keys(params)) {
        if (params[key]) result[key] = params[key];
    }
    return result;
}

function phpSearchPDX(params) {
    const searchparams = formatForPdx(params);
    return phpApi
        .get('/patient/pdx', { params: searchparams })
        .then((result) => result.results)
        .catch((error) => {
            const err = { ...error };
            if (error.status === -1) {
                err.statusText = 'Request Was Aborted or Timed Out';
                err.data.message = `Here are some additional information, request timeout: ${error.config.timeout}`;
            }
            throw err;
        });
}

function formatForSTM(params) {
    const fieldMapping = {
        firstName: 'first_name',
        lastName: 'last_name',
        zipCode: 'zip',
        birthDate: 'birth_date',
        externalId: 'external_id',
        disabledBy: 'disabled_by',
    };
    const result = {};

    Object.entries(params).forEach(([key, value]) => {
        if (key === 'disabledBy') {
            if (value !== undefined && value !== null) {
                result[fieldMapping[key]] = value;
            }
            return;
        }

        if (value) {
            const mappedKey = fieldMapping[key] ?? key;
            result[mappedKey] = value;
        }
    });

    return result;
}

function phpSearchSTM(searchParams) {
    const params = formatForSTM(searchParams);
    return phpApi
        .get('/patient/search', { params })
        .then((result) => result.results)
        .catch((err) => {
            throw err;
        });
}

export { phpGetPDXPatient, phpSearchPDX, phpSearchSTM, slsGetPDXPatient, slsSearchPDX };
